import { NgModule } from "@angular/core";
import { DebounceClickDirective } from "./no-double-click.directive";
import { DynamicInputDirective } from "./dynamic-input.directive";

@NgModule({
  declarations: [
    DebounceClickDirective,
    DynamicInputDirective,
  ],
  exports: [
    DebounceClickDirective,
    DynamicInputDirective
  ]
})
export class DirectivesModule {}
